import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'userIdMismatchError',
    templateUrl: './userIdMismatchError.component.html',
    styles: [`
    td, th.mat-header-cell {
    text-align : center;
    }
    `],
    animations: [
        trigger('dropIn', [
            transition(':enter', [
                style({ transform: 'translateY(-40px)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateY(-40px)', opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
/** UserIdMismatchError component*/
export class UserIdMismatchError {

   
    public errorType: string;

   

    constructor(private readonly http: HttpClient, private route: ActivatedRoute,) {
       
       this.errorType = route.snapshot.params['errorType'];
       
    }

   

}